import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Redirect, useParams } from "react-router-dom";

import FormikControl from "@Components/FormikControl/FormikControl.js";
import { Button } from "@material-ui/core";
import useStyles from "@Views/Styles/LoginStyles";
import { useAuth } from "@Views/Authentication/AuthContext";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import FGVLogo from "assets/img/fgv-logo.png";
import eightAxios from "configs/axiosConfig";
import { URLS } from "configs/constants";
import { getRedirectUrl } from "utils";

const CreateFirstTimePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const params = useParams();
  const AVAILABILITY_URL = "/new-user/check-availability/";

  let initialValues = {
    password: "",
    password1: "",
  };

  const {
    login,
    loggedIn,
    authLoading,
    errorMessage,
    logout,
    setErrorMessage,
  } = useAuth();

  const onSubmit = (values) => {
    console.log("ID: ", params.employee_id);
    if (values.password.length && values.password1.length) {
      login(params.employee_id, values.password, values.password1, true);
    }
  };

  const validationSchema = Yup.object({
    password: Yup.string().required("New Password"),
    password1: Yup.string().required("Re-enter New Password"),
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  if (loggedIn) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl)
      return (
        <Redirect to={{ pathname: redirectUrl, state: { login: true } }} />
      );
    setErrorMessage("User doesn't have any module/s assigned.");
    // logout();
  }

  const checkAvailability = () => {
    setLoading(true);
    const config = { params: { employee_id: params.employee_id } };
    eightAxios
      .get(AVAILABILITY_URL, config)
      .then((response) => {
        if (!response.data.availability) {
          setRedirect(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    checkAvailability();
  }, []);

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: URLS.LOGIN,
        }}
      />
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {!authLoading ? (
        (formik) => {
          return (
            <Form style={{ width: "100%" }}>
              <Grid
                className={classes.root}
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={10} sm={6} lg={3}>
                  <img src={FGVLogo} alt="FGV" width={200} />
                </Grid>
                <Grid item xs={10} sm={6} lg={3}>
                  <Typography variant="h4">Set Password</Typography>
                </Grid>

                <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                  <FormikControl
                    control="restricted"
                    regex={/[^ ]/i}
                    variant="outlined"
                    label={
                      formik.touched.password && formik.errors.password
                        ? formik.errors.password
                        : "New Password"
                    }
                    labelClasses={classes.labelStyles}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <FormikControl
                    control="restricted"
                    regex={/[^ ]/i}
                    labelClasses={classes.labelStyles}
                    variant="outlined"
                    label={
                      formik.touched.password1 && formik.errors.password1
                        ? formik.errors.password1
                        : "Re-Enter New Password"
                    }
                    name="password1"
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Grid item>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="error"
                    >
                      {errorMessage.length ? errorMessage : errorMessage}
                    </Typography>
                  </Grid>

                  <Button
                    type="submit"
                    disabled={!formik.isValid || authLoading}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }
      ) : (
        <LoadingIcon image text="Logging in" />
      )}
    </Formik>
  );
};

export default CreateFirstTimePassword;
